import './awards.scss';
import * as React from 'react';
import useAllAwards from '../../hooks/staticQueries/home/useAwards';
import { SectionTitle } from '../layout/sectionTitle';
import { LinkWrapper } from '../linkWrapper';
import { LazyCosmosImage } from '../media/cosmosImage';
export const Awards = () => {
    const { awards } = useAllAwards();
    return (<div className="awards-wrapper">
      <SectionTitle title="Some of our Awards"/>

      <div className="awards">
        {awards.map((award) => (<Award {...award} key={award.name}/>))}
      </div>
    </div>);
};
export const Award = ({ url, name, image, year }) => (<LinkWrapper to={url} title={`${name} ${year}`}>
    <div className="award">
      <LazyCosmosImage ticket={image[0].ticket} alt={`${name} ${year}`}/>
    </div>
  </LinkWrapper>);
